<template>
  <div>
    <v-dialog v-model="dialogOpen" persistent max-width="1200">
      <v-card>
        <v-card-title>Create Retention Lead</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4"><v-select v-model="form.source" label="Source" :items="getDropdowns.sources" dense outlined hide-details></v-select></v-col>
            <v-col cols="12" md="4"><v-select v-model="form.department" label="Department" :items="getDropdowns.departments" dense outlined hide-details></v-select></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4"><v-select v-model="form.reason.category" label="Contact Reason Category" :items="getDropdowns.categories" @change="form.reason.reason='';form.reason.subReason=''" return-object dense outlined hide-details></v-select></v-col>
            <v-col cols="12" md="4"><v-select v-model="form.reason.reason" label="Contact Reason" :items="getDropdowns.reasons[form.reason.category.value]" :disabled="form.reason.category.value===undefined" return-object dense outlined hide-details></v-select></v-col>
            <v-col cols="12" md="4"><v-select v-model="form.reason.subReason" label="Contact Sub-reason" :items="getDropdowns.subReasons[form.reason.reason.value]" :disabled="form.reason.reason.value===undefined" dense outlined hide-details></v-select></v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="form.notes" label="Notes" dense outlined hide-details clearbale></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <v-data-table v-model="selected" :headers="headers" :items="tableProducts" disable-sort hide-default-footer show-select item-key="id">
                    <template v-slot:item.id="{ item }"><span class="body--text">{{ item.id }}</span></template>
                    <template v-slot:item.kind="{ item }"><span class="body--text">{{ item.kind }}</span></template>
                    <template v-slot:item.status="{ item }"><span class="body--text">{{ item.status }}</span></template>
                    <template v-slot:item.cli_url="{ item }"><span class="body--text" v-html="item.cli_url"></span></template>
                    <template v-slot:item.live="{ item }"><span class="body--text">{{ item.live }}</span></template>
                    <template v-slot:item.contract_end="{ item }"><span class="body--text">{{ item.contract_end }}</span></template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text small color="error" v-if="errorMessage.length>0">Please select a {{errorMessage.join(', ')}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" small :disabled="submitDisabled" :loading="createLoading" @click="submitRetention">CREATE</v-btn>
          <v-btn color="primary" small outlined @click="$emit('close-dialog')">CANCEL</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";

  export default {
    props: ['dialogOpen','products','acc_id'],
    data() {
      return {
        singleSelect: true,
        selected: [],
        kindMap: {web:'Website',voip:'VoIP',telco:'Telco'},
        headers: [
          {text: "", value: "selected"},
          {text: "ID", value: "id"},
          {text: "Kind", value: "kind"},
          {text: "Status", value: "status"},
          {text: "CLI / URL", value: "cli_url"},
          {text: "Live", value: "live"},
          {text: "Contract End", value: "contract_end"},
        ],
        form: {source:'',reason:{category:'',reason:'',subReason:''},department:'',notes:'',products:[]},
        createLoading: false,
        
      }
    },
    watch: {
      dialogOpen(val) {
        if(val){
          if(this.hasUserGotRole('can-create-retention-leads')){
            if(this.tableProducts.length===1){
              this.selected = [this.tableProducts[0].id].map(id => ({ id }));
            }
          }else{
            this.setAlert({type: 'error', message: `You are not authorized to create retention leads!`});
            this.$emit('close-dialog');
          }
        }
      }
    },
    methods: {
      ...mapActions('retention',['createRetentionLead']),
      ...mapActions('alerts', ['setAlert']),
      sortProducts(){
        let prods = [];
        this.selected.forEach(pr => {
          prods.push({
            product_id: pr.id,
            contact_category: this.form.reason.category.text,
            contact_reason: this.form.reason.reason.text,
            contact_sub_reason: this.form.reason.subReason,
          });
        });
        return prods;
      },
      async submitRetention(){
        this.createLoading = true;
        let fm = this.form;
        let pl = {
          account_id: this.acc_id,
          notes: fm.notes,
          source: fm.source,
          department: fm.department,
          cancellation_records: this.sortProducts()
        };
        let id = await this.createRetentionLead({payload:pl});
        if(id!==undefined){
          this.$router.push(`/retention/${id}/`);
        }
        this.createLoading = false;
      },
      cli_url(kind,prod) {
        switch(kind){
          case 'voip':
            return (prod.service.clis.length!==0)?prod.service.clis.join(', '):'-';
          case 'web':
            return `<a href="${prod.service.internal}" target="_blank">${prod.service.internal}</a>`;
          default:
            return prod.service.line_number;
        }
      }
    },
    computed: {
      ...mapGetters('globals',['hasUserGotRole']),
      ...mapGetters('retention',['getDropdowns']),

      errorMessage() {
        let fm = this.form;
        const errors = [];

        if(fm.source===''){ errors.push('Source');}
        if(fm.department===''){ errors.push('Department');}
        if(this.selected.length===0){ errors.push('Product');}
        if (fm.reason.category.value === 'other' && fm.reason.reason === '') {
          errors.push('Contact Reason');
        }

        return errors;
      },

      submitDisabled(){
        return this.errorMessage.length > 0 || this.createLoading;
      },

      tableProducts() {
        let products = [];
        this.products.forEach(prod => {
          if(prod.parent_product_id===null){
            let kind = prod.product_kind.toLowerCase();
            products.push({
              id: prod.id,
              kind: this.kindMap[kind],
              status: prod.status,
              cli_url: this.cli_url(kind,prod),
              live: prod.contract_start_date,
              contract_end: prod.contract_end_date,
            });
          }
        });
        return products;
      }
    },
  }
</script>

<style lang="scss" scoped>
  .v-data-table ::v-deep tbody tr {
    cursor: pointer !important;
  }
</style>
